.tabsContainer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
}

.tabItemsContainer {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid var(--static-divider-standard);
}

.tabItem {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  box-sizing: border-box;
  cursor: pointer;
  width: fit-content;
}

.highlight {
  position: absolute;
  bottom: -1px;
  height: 2px;
  background-color: var(--color-primary); /* the color of the bottom border */
  transition: left 200ms ease, width 200ms ease; /* animate changes to left/width */
}

.tabItem:not(.tabItemDisabled):hover {
  color: var(--color-primary);
}

.tabItemActive {
  color: var(--static-text-strong);
  font-weight: var(--font-weight-strong);
}

.tabItemDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tabChildrenContainer {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
}
